module.exports = __webpack_public_path__ + "static/media/news-bottom.bab97e37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news-bottom.png
// module id = 842
// module chunks = 2